interface CallbackAttempt {
  callbackUrl: string;
  completion: Promise<string>;
}

let activeAttempt: CallbackAttempt | null = null;

/**
 * OAuth authorization codes are single-use. React StrictMode may start an
 * effect twice and an auth boundary may remount while the exchange is still
 * running, so every mount in this document shares exactly one exchange.
 */
export function completeCallbackOnce(
  callbackUrl: string,
  complete: () => Promise<string>,
): Promise<string> {
  if (activeAttempt?.callbackUrl === callbackUrl) {
    return activeAttempt.completion;
  }
  const completion = complete();
  activeAttempt = { callbackUrl, completion };
  return completion;
}
